export default {"src":"/planos/_next/static/media/efx.366f7065.svg","height":15,"width":50,"blurWidth":0,"blurHeight":0};